// eslint-disable-next-line import/no-cycle
import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const getMasterDataApi = (params = {}) =>
  DataService.get(
    `/master-data${params?.fields || params?.field ? `?${getQueryString(params)}` : ''}`,
  );

export const getKpiApi = (query) => DataService.get(`/kpis?${getQueryString(query)}`);

export const getPackageListMasterApi = () => DataService.get('/package-list');
